import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'splice' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/splice.js.map
